var render = function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _vm.subPath ? _c('section', {
    staticClass: "AppHeader__container",
    "class": {
      experience: _vm.isAppModeExperience
    }
  }, [_c('div', {
    staticClass: "AppHeader__left-header"
  }, [_c('p', {
    on: {
      "click": _vm.goInsitution
    }
  }, [_vm._v(_vm._s(_vm.headerPath))]), _c('span', [_vm._v(" / ")]), _c('p', {
    "class": {
      active: _vm.detailPaths.length == 0 && !_vm.$route.params.name
    },
    on: {
      "click": _vm.clickMenu
    }
  }, [_vm._v(" " + _vm._s(_vm.tt(_vm.subPath)) + " ")]), _vm.detailPaths.length > 0 ? _c('b', [_vm._v(" / " + _vm._s(_vm.tt(_vm.detailPaths[0])))]) : _vm.$route.params.name ? _c('b', [_vm._v(" / " + _vm._s(_vm.$route.params.name))]) : _vm._e()]), _c('div', {
    staticClass: "AppHeader__right-header"
  }, [_vm._m(0), _c('app-notice'), !_vm.isAppModeExperience ? _c('app-header-menu') : _vm._e()], 1)]) : _vm._e();
}
var staticRenderFns = [function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('a', {
    staticClass: "AppHeader__top-banner",
    attrs: {
      "href": "https://lab-manager.com/survey",
      "target": "_blank"
    }
  }, [_c('img', {
    attrs: {
      "src": require("@/assets/images/2026/top1.png"),
      "alt": "banner"
    }
  })]);
}]

export { render, staticRenderFns }